<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ paymentType['PaymentTypeName']}}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>

  <form [formGroup]="paymentForm">
<ion-grid *ngIf="paymentType['promptFor'].toLowerCase()=='creditcard'">
  <ion-row>
    <ion-col>
      <ion-item lines="none">
        <ion-label >Label:</ion-label>
        <ion-input required  type="text" formControlName="label"></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-item lines="none">
        <ion-label>Card Holder Name:</ion-label>
        <ion-input  required  type="text" formControlName="cardName"></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-item lines="none">
        <ion-label >Card Number:</ion-label>
        <ion-input  maxlength="16" minlength="13" required  type="text" formControlName="cardNumber"></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-item lines="none">
        <ion-label >Card Expiry:</ion-label>
        <ion-select  required [interfaceOptions]="monthOptions" formControlName="cardExpiryMonth"   placeholder="Month">
          <ion-select-option value="01">1</ion-select-option>
          <ion-select-option value="02">2</ion-select-option>
          <ion-select-option value="03">3</ion-select-option>
          <ion-select-option value="04">4</ion-select-option>
          <ion-select-option value="05">5</ion-select-option>
          <ion-select-option value="06">6</ion-select-option>
          <ion-select-option value="07">7</ion-select-option>
          <ion-select-option value="08">8</ion-select-option>
          <ion-select-option value="09">9</ion-select-option>
          <ion-select-option value="10">10</ion-select-option>
          <ion-select-option value="11">11</ion-select-option>
          <ion-select-option value="12">12</ion-select-option>
        </ion-select>
        <ion-select required [interfaceOptions]="yearOptions" formControlName="cardExpiryYear"   placeholder="Year">
          <ion-select-option
          *ngFor="let year of expiryDates"
          [value]=year>{{year}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-item lines="none">
        <ion-label >CVV:</ion-label>
        <ion-input maxlength="4" minlength="3" required  type="text" formControlName="cardCVVD"></ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-button [disabled]="!paymentForm.valid" expand="block" color="dark" (click)="postPaymentMethod()">Add Payment Method</ion-button>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="errors.length>0">
    <ion-col size="12" *ngFor="let error of errors" style="text-align: center;font-weight:bold;">
      <ion-note color="danger">- {{error}}</ion-note>
    </ion-col>
  </ion-row>
</ion-grid>
</form>
<app-iframe *ngIf="paymentType['gateway'].toString().toLowerCase()=='monerischeckout'" [paymentType]="paymentType"></app-iframe>
</ion-content>
